import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'BForm',
  emits: ["submit"],
  setup(__props, { emit }) {



const onSubmit = (event: Event) => {
  emit("submit", event);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", { onSubmit: onSubmit }, [
    _renderSlot(_ctx.$slots, "default")
  ], 32))
}
}

})